import { useCallback, useState } from "react";
import { SellerPubMissionBingoStatusFilter } from "../../api/pub-mission-bingo";
import BingoFormPopup from "./components/bingo-form-popup";
import Table from "./components/table/table";
import { useEventBingo } from "./hooks/use-event-bingo";
import * as S from "./styles";

const STATUS_TABS = [
  { label: "전체", value: SellerPubMissionBingoStatusFilter.ALL },
  { label: "진행중", value: SellerPubMissionBingoStatusFilter.IN_PROGRESS },
  { label: "종료", value: SellerPubMissionBingoStatusFilter.ENDED },
];

const EventBingo = () => {
  const {
    pubId,
    bingoList,
    currentPage,
    setCurrentPage,
    totalPages,
    searchQuery,
    sizeFilter,
    statusFilter,
    handleSearchQueryChange,
    handleSizeFilterChange,
    handleStatusFilterChange,
    refreshBingoList,
  } = useEventBingo();

  const [editingBingoId, setEditingBingoId] = useState<number | undefined>();
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  const closeFormPopup = useCallback(() => {
    setIsCreateOpen(false);
    setEditingBingoId(undefined);
  }, []);

  const isFormOpen = isCreateOpen || editingBingoId !== undefined;

  return (
    <S.EventBingoWrapper>
      <S.PageHeaderArea>
        <S.TitleRow>
          <S.Title>빙고 관리</S.Title>
          <S.CreateButton type="button" onClick={() => setIsCreateOpen(true)}>
            + 빙고 등록
          </S.CreateButton>
        </S.TitleRow>

        <S.TabRow>
          {STATUS_TABS.map((tab) => (
            <S.TabItem
              key={tab.value}
              type="button"
              $selected={statusFilter === tab.value}
              onClick={() => handleStatusFilterChange(tab.value)}
            >
              {tab.label}
            </S.TabItem>
          ))}
        </S.TabRow>
      </S.PageHeaderArea>

      <S.ContentScrollArea>
        <S.ContentBody>
          <S.TableSection>
            <Table
              list={bingoList}
              pubId={pubId}
              sizeFilter={sizeFilter}
              searchQuery={searchQuery}
              totalPages={totalPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              handleSearchQueryChange={handleSearchQueryChange}
              handleSizeFilterChange={handleSizeFilterChange}
              onRefresh={refreshBingoList}
              onEdit={(bingo) => setEditingBingoId(bingo.id)}
            />
          </S.TableSection>
        </S.ContentBody>
      </S.ContentScrollArea>

      {isFormOpen && pubId > 0 && (
        <BingoFormPopup
          pubId={pubId}
          bingoId={editingBingoId}
          onClose={closeFormPopup}
          onSuccess={refreshBingoList}
        />
      )}
    </S.EventBingoWrapper>
  );
};

export default EventBingo;
